module.exports = __webpack_public_path__ + "img/list_5.064ba0a4.png";